import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/es.object.from-entries.js";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

var _excluded = ["disabled"];

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };

  var t,
      e = {},
      r = Object.prototype,
      n = r.hasOwnProperty,
      o = Object.defineProperty || function (t, e, r) {
    t[e] = r.value;
  },
      i = "function" == typeof Symbol ? Symbol : {},
      a = i.iterator || "@@iterator",
      c = i.asyncIterator || "@@asyncIterator",
      u = i.toStringTag || "@@toStringTag";

  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }

  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }

  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
        a = Object.create(i.prototype),
        c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }

  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }

  e.wrap = wrap;
  var h = "suspendedStart",
      l = "suspendedYield",
      f = "executing",
      s = "completed",
      y = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
      v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);

  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }

  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);

      if ("throw" !== c.type) {
        var u = c.arg,
            h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }

      a(c.arg);
    }

    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }

        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }

  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");

      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }

      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;

        if (c) {
          var u = maybeInvokeDelegate(c, n);

          if (u) {
            if (u === y) continue;
            return u;
          }
        }

        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);

        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }

        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }

  function maybeInvokeDelegate(e, r) {
    var n = r.method,
        o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }

  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }

  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }

  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;

      if (!isNaN(e.length)) {
        var o = -1,
            i = function next() {
          for (; ++o < e.length;) {
            if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
          }

          return next.value = t, next.done = !0, next;
        };

        return i.next = i;
      }
    }

    throw new TypeError(_typeof(e) + " is not iterable");
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
        r = [];

    for (var n in e) {
      r.push(n);
    }

    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) {
        "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      }
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;

      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }

      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
            a = i.completion;
        if ("root" === i.tryLoc) return handle("end");

        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");

          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];

        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }

      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];

        if (r.tryLoc === t) {
          var n = r.completion;

          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }

          return o;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);

  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Dropdown, Form, FormControl, Modal, ProgressBar, Row, Spinner } from 'react-bootstrap';
import { ArrowsCollapse, CheckLg, ExclamationTriangle, ExclamationTriangleFill, FileEarmarkArrowDownFill, FileEarmarkCode, FileEarmarkSpreadsheet, InfoCircleFill } from 'react-bootstrap-icons';
import { Field, Form as FinalForm } from 'react-final-form';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { RESULTS_PER_PAGE } from '../config';
import { getPersonsFromFormData } from '../form';
import { useFormContext } from '../state/form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var EXTENSION_CSV = 'csv';
var EXTENSION_JSON = 'json';
var EXPORT_CURRENT = 'current';
var EXPORT_FIRST_N = 'first';
var EXPORT_ALL = 'all';
var MAX_EXPORT_COUNT = 2500;

function SelectionInput(_ref) {
  var name = _ref.name,
      value = _ref.value,
      values = _ref.values,
      label = _ref.label,
      renderValue = _ref.renderValue,
      setValue = _ref.setValue;
  return /*#__PURE__*/_jsxs(Row, {
    className: "mt-1",
    children: [/*#__PURE__*/_jsx(Col, {
      xs: 6,
      sm: 5,
      className: "my-auto",
      children: label
    }), /*#__PURE__*/_jsx(Col, {
      xs: 6,
      sm: 7,
      children: /*#__PURE__*/_jsxs(Dropdown, {
        as: "span",
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        children: [/*#__PURE__*/_jsx(Dropdown.Toggle, {
          variant: "light",
          id: "dropdown-basic",
          children: renderValue(values[value])
        }), /*#__PURE__*/_jsx(Dropdown.Menu, {
          className: "width-min",
          children: Object.entries(values).map(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                key = _ref3[0],
                v = _ref3[1];

            return /*#__PURE__*/_jsx(Dropdown.Item, {
              active: value === key,
              onClick: function onClick() {
                return setValue(name, key);
              },
              children: renderValue(v)
            }, key);
          })
        })]
      })
    })]
  });
}

SelectionInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  values: PropTypes.object.isRequired,
  label: PropTypes.any.isRequired,
  renderValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired
};
export function DownloadButton(_ref4) {
  var _availableFileFormats;

  var disabled = _ref4.disabled,
      props = _objectWithoutProperties(_ref4, _excluded);

  var intl = useIntl();

  var _useFormContext = useFormContext(),
      formState = _useFormContext.state;

  var paginationSize = Math.max.apply(Math, _toConsumableArray(RESULTS_PER_PAGE));
  var canExportAll = formState.data.count <= MAX_EXPORT_COUNT;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isExporting = _useState4[0],
      setExporting = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isDone = _useState6[0],
      setDone = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      progress = _useState8[0],
      setProgress = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isError = _useState10[0],
      setError = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isCsvWarning = _useState12[0],
      setCsvWarning = _useState12[1];

  var handleButtonClick = function handleButtonClick(e) {
    e.target.blur();
    setShow(true);
    setDone(false);
    setProgress(0);
    setError(false);
    setCsvWarning(false);
  };

  var handleHide = function handleHide() {
    if (!isExporting) {
      // Cannot hide if exporting
      setShow(false);
    }
  };

  var availableFileFormats = (_availableFileFormats = {}, _defineProperty(_availableFileFormats, EXTENSION_CSV, {
    name: 'CSV',
    icon: FileEarmarkSpreadsheet,
    extension: EXTENSION_CSV
  }), _defineProperty(_availableFileFormats, EXTENSION_JSON, {
    name: 'JSON',
    icon: FileEarmarkCode,
    extension: EXTENSION_JSON
  }), _availableFileFormats);
  var availableCsvFieldSeparators = {
    comma: {
      name: intl.formatMessage({
        id: 'export.select_value_separator.value.comma'
      }),
      symbol: ','
    },
    semicolon: {
      name: intl.formatMessage({
        id: 'export.select_value_separator.value.semicolon'
      }),
      symbol: ';'
    },
    tab: {
      name: intl.formatMessage({
        id: 'export.select_value_separator.value.tab'
      }),
      symbol: '\t'
    }
  };
  var availableCsvLineSeparators = {
    lf: {
      name: 'Unix',
      symbol: '\n'
    },
    crlf: {
      name: 'Windows',
      symbol: '\r\n'
    }
  };
  var fieldNamesFrench = {
    // TODO localize that
    nom: 'nom',
    prenom: 'prenom',
    gender: 'sexe',
    birthDate: 'date_naissance',
    birthPlace: 'lieu_naissance',
    deathDate: 'date_deces',
    deathPlace: 'lieu_deces',
    actCode: 'acte'
  };
  var fieldNamesOrder = ['nom', 'prenom', 'gender', 'birthDate', 'birthPlace', 'deathDate', 'deathPlace', 'actCode'];
  var genderNamesFrench = {
    male: 'M',
    female: 'F'
  };
  var defaultGender = '?';

  var dataToString = function dataToString(array, fileFormat, options) {
    var transformGender = function transformGender(gender) {
      return gender != null ? gender ? genderNamesFrench.male : genderNamesFrench.female : defaultGender;
    };

    if (fileFormat === EXTENSION_CSV) {
      var lines = [];
      var fieldSeparator = availableCsvFieldSeparators[options.exportCsvFieldSeparator].symbol;
      var lineSeparator = availableCsvLineSeparators[options.exportCsvLineSeparator].symbol;
      lines.push(fieldNamesOrder.map(function (key) {
        return fieldNamesFrench[key];
      }).join(fieldSeparator));
      array.forEach(function (obj) {
        return lines.push(fieldNamesOrder.map(function (key) {
          var value = key !== 'gender' ? obj[key] : transformGender(obj[key]);

          if (value == null) {
            return '';
          } else if (value.includes(fieldSeparator)) {
            var doubleQuotes = '"';
            return doubleQuotes + value.replaceAll(doubleQuotes, doubleQuotes + doubleQuotes) + doubleQuotes;
          } else {
            return value;
          }
        }).join(fieldSeparator));
      });
      return lines.join(lineSeparator);
    } else if (fileFormat === EXTENSION_JSON) {
      var cleanArray = array.map(function (obj) {
        return Object.fromEntries(fieldNamesOrder.map(function (key) {
          var cleanValue = key !== 'gender' ? obj[key] : transformGender(obj[key]);
          return [fieldNamesFrench[key], cleanValue];
        }));
      });

      if (options.exportJsonPretty.length > 0) {
        var spacing = 2;
        return JSON.stringify(cleanArray, null, spacing);
      } else {
        return JSON.stringify(cleanArray);
      }
    } else {
      throw new Error();
    }
  };

  var downloadStringAsFile = function downloadStringAsFile(str, filename) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(str));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  var renderForm = function renderForm(_ref5) {
    var handleSubmit = _ref5.handleSubmit,
        values = _ref5.values,
        setValue = _ref5.form.mutators.setValue;
    return /*#__PURE__*/_jsxs(Form, {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsx(Modal.Header, {
        closeButton: !isExporting,
        children: /*#__PURE__*/_jsx(Modal.Title, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "export.title"
          })
        })
      }), isDone ? !isError ? /*#__PURE__*/_jsxs(Modal.Body, {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "text-success",
          children: /*#__PURE__*/_jsx(CheckLg, {
            className: "icon"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          id: "export.success"
        }), isCsvWarning && /*#__PURE__*/_jsxs("div", {
          className: "mt-5",
          children: [/*#__PURE__*/_jsxs("h2", {
            className: "h5",
            children: [/*#__PURE__*/_jsx(InfoCircleFill, {
              className: "icon mr-2"
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              id: "export.tips.csv.title"
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "text-left",
            children: [/*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                id: "export.tips.csv.description"
              })
            }), /*#__PURE__*/_jsxs("ul", {
              className: "pl-4",
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  id: "export.tips.csv.charset_encoding",
                  values: {
                    charset: /*#__PURE__*/_jsx("strong", {
                      children: "Unicode"
                    }),
                    encoding: /*#__PURE__*/_jsx("strong", {
                      children: "UTF-8"
                    })
                  }
                })
              }), /*#__PURE__*/_jsxs("li", {
                children: [/*#__PURE__*/_jsx(FormattedMessage, {
                  id: "export.tips.csv.cells_format"
                }), /*#__PURE__*/_jsxs("ul", {
                  className: "pl-4",
                  children: [/*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      id: "export.tips.csv.cells_format_for_columns",
                      values: {
                        format: /*#__PURE__*/_jsx("strong", {
                          children: /*#__PURE__*/_jsx(FormattedMessage, {
                            id: "export.tips.csv.cells_format_text"
                          })
                        }),
                        columns: /*#__PURE__*/_jsx(FormattedMessage, {
                          id: "export.tips.csv.columns_text",
                          values: {
                            surname: /*#__PURE__*/_jsx("code", {
                              children: fieldNamesFrench.nom
                            }),
                            given_name: /*#__PURE__*/_jsx("code", {
                              children: fieldNamesFrench.prenom
                            }),
                            gender: /*#__PURE__*/_jsx("code", {
                              children: fieldNamesFrench.gender
                            }),
                            birth_place: /*#__PURE__*/_jsx("code", {
                              children: fieldNamesFrench.birthPlace
                            }),
                            death_place: /*#__PURE__*/_jsx("code", {
                              children: fieldNamesFrench.deathPlace
                            }),
                            act_code: /*#__PURE__*/_jsx("code", {
                              children: fieldNamesFrench.actCode
                            })
                          }
                        })
                      }
                    })
                  }), /*#__PURE__*/_jsx("li", {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      id: "export.tips.csv.cells_format_for_columns",
                      values: {
                        format: /*#__PURE__*/_jsx("strong", {
                          children: /*#__PURE__*/_jsx(FormattedMessage, {
                            id: "export.tips.csv.cells_format_date"
                          })
                        }),
                        columns: /*#__PURE__*/_jsx(FormattedMessage, {
                          id: "export.tips.csv.columns_date",
                          values: {
                            birth_date: /*#__PURE__*/_jsx("code", {
                              children: fieldNamesFrench.birthDate
                            }),
                            death_date: /*#__PURE__*/_jsx("code", {
                              children: fieldNamesFrench.deathDate
                            })
                          }
                        })
                      }
                    })
                  })]
                })]
              })]
            })]
          })]
        })]
      }) : /*#__PURE__*/_jsxs(Modal.Body, {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "text-danger",
          children: /*#__PURE__*/_jsx(ExclamationTriangle, {
            className: "icon"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          id: "export.error"
        })]
      }) : isExporting ? /*#__PURE__*/_jsxs(Modal.Body, {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "mb-2",
          children: /*#__PURE__*/_jsx(Spinner, {
            animation: "border"
          })
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          id: "export.loading"
        }), /*#__PURE__*/_jsx(ProgressBar, {
          min: 0,
          max: 1,
          now: progress,
          className: "mt-2"
        })]
      }) : /*#__PURE__*/_jsxs(Modal.Body, {
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Field, {
            name: "exportSize",
            type: "radio",
            value: EXPORT_CURRENT,
            render: function render(_ref6) {
              var input = _ref6.input;
              return /*#__PURE__*/_jsx(Form.Check, _objectSpread({
                id: "export-radio-current",
                label: /*#__PURE__*/_jsx(FormattedMessage, {
                  id: "export.radio.current_page",
                  values: {
                    entries: /*#__PURE__*/_jsx("strong", {
                      children: /*#__PURE__*/_jsx(FormattedNumber, {
                        value: formState.data.results.length
                      })
                    }),
                    n: formState.data.results.length
                  }
                })
              }, input));
            }
          }), /*#__PURE__*/_jsx(Field, {
            name: "exportSize",
            type: "radio",
            value: EXPORT_FIRST_N,
            render: function render(_ref7) {
              var input = _ref7.input;
              return (
                /*#__PURE__*/
                // TODO pluralize
                _jsx(Form.Check, _objectSpread({
                  id: "export-radio-first-n",
                  label: /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx(FormattedMessage, {
                      id: "export.radio.first"
                    }), /*#__PURE__*/_jsx(Field, {
                      name: "exportFirst",
                      render: function render(_ref8) {
                        var childInput = _ref8.input;
                        return /*#__PURE__*/_jsx(FormControl, _objectSpread({
                          type: "number",
                          disabled: !input.checked,
                          min: 1,
                          max: MAX_EXPORT_COUNT,
                          placeholder: intl.formatMessage({
                            id: 'export.amount'
                          })
                        }, childInput));
                      }
                    })]
                  })
                }, input))
              );
            }
          }), /*#__PURE__*/_jsx(Field, {
            name: "exportSize",
            type: "radio",
            value: EXPORT_ALL,
            render: function render(_ref9) {
              var input = _ref9.input;
              return /*#__PURE__*/_jsx(Form.Check, _objectSpread({
                id: "export-radio-all",
                disabled: !canExportAll,
                label: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(FormattedMessage, {
                    id: "export.radio.all",
                    values: {
                      entries: /*#__PURE__*/_jsx("strong", {
                        children: /*#__PURE__*/_jsx(FormattedNumber, {
                          value: formState.data.count
                        })
                      }),
                      n: formState.data.count
                    }
                  }), !canExportAll && /*#__PURE__*/_jsxs("span", {
                    className: "text-warning",
                    children: [/*#__PURE__*/_jsx(ExclamationTriangleFill, {
                      className: "icon ml-3 mr-2"
                    }), "> ", /*#__PURE__*/_jsx(FormattedNumber, {
                      value: MAX_EXPORT_COUNT
                    })]
                  })]
                })
              }, input));
            }
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "mt-4",
          children: /*#__PURE__*/_jsx(Field, {
            name: "exportFileFormat",
            render: function render(_ref10) {
              var _ref10$input = _ref10.input,
                  value = _ref10$input.value,
                  name = _ref10$input.name;
              return /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(SelectionInput, {
                  name: name,
                  value: value,
                  values: availableFileFormats,
                  label: /*#__PURE__*/_jsx(FormattedMessage, {
                    id: "export.select_format.label"
                  }),
                  renderValue: function renderValue(_ref11) {
                    var name = _ref11.name,
                        Icon = _ref11.icon;
                    return /*#__PURE__*/_jsxs(_Fragment, {
                      children: [/*#__PURE__*/_jsx(Icon, {
                        className: "icon mr-2"
                      }), name]
                    });
                  },
                  setValue: setValue
                }), value === EXTENSION_CSV && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Field, {
                    name: "exportCsvFieldSeparator",
                    render: function render(_ref12) {
                      var _ref12$input = _ref12.input,
                          childValue = _ref12$input.value,
                          childName = _ref12$input.name;
                      return /*#__PURE__*/_jsx(SelectionInput, {
                        name: childName,
                        value: childValue,
                        values: availableCsvFieldSeparators,
                        label: /*#__PURE__*/_jsx(FormattedMessage, {
                          id: "export.select_value_separator.label"
                        }),
                        renderValue: function renderValue(_ref13) {
                          var name = _ref13.name;
                          return /*#__PURE__*/_jsx(_Fragment, {
                            children: name
                          });
                        },
                        setValue: setValue
                      });
                    }
                  }), /*#__PURE__*/_jsx(Field, {
                    name: "exportCsvLineSeparator",
                    render: function render(_ref14) {
                      var _ref14$input = _ref14.input,
                          childValue = _ref14$input.value,
                          childName = _ref14$input.name;
                      return /*#__PURE__*/_jsx(SelectionInput, {
                        name: childName,
                        value: childValue,
                        values: availableCsvLineSeparators,
                        label: /*#__PURE__*/_jsx(FormattedMessage, {
                          id: "export.select_line_separator.label"
                        }),
                        renderValue: function renderValue(_ref15) {
                          var name = _ref15.name;
                          return /*#__PURE__*/_jsx(_Fragment, {
                            children: name
                          });
                        },
                        setValue: setValue
                      });
                    }
                  })]
                }), value === EXTENSION_JSON && /*#__PURE__*/_jsx(Field, {
                  name: "exportJsonPretty",
                  type: "checkbox",
                  value: "checked",
                  render: function render(_ref16) {
                    var childInput = _ref16.input;
                    return /*#__PURE__*/_jsx(Form.Check, _objectSpread({
                      id: "export-radio-json-pretty",
                      label: "Formatter le code"
                    }, childInput));
                  }
                })]
              });
            }
          })
        })]
      }), /*#__PURE__*/_jsxs(Modal.Footer, {
        children: [!isExporting && /*#__PURE__*/_jsxs(Button, {
          variant: "dark",
          onClick: handleHide,
          children: [/*#__PURE__*/_jsx(ArrowsCollapse, {
            className: "icon mr-2"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            id: "export.button_close"
          })]
        }), /*#__PURE__*/_jsxs(Button, {
          type: "submit",
          variant: "primary",
          disabled: isExporting || isDone,
          children: [/*#__PURE__*/_jsx(FileEarmarkArrowDownFill, {
            className: "icon mr-2"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            id: "export.button_download"
          })]
        })]
      })]
    });
  };

  var submitHandler = function submitHandler(data) {
    var prefix = intl.formatMessage({
      id: 'export.filename'
    });
    var filename = "".concat(prefix, ".").concat(availableFileFormats[data.exportFileFormat].extension);
    setCsvWarning(data.exportFileFormat === EXTENSION_CSV);

    if (data.exportSize === EXPORT_CURRENT) {
      var resultString = dataToString(formState.data.results, data.exportFileFormat, data);
      downloadStringAsFile(resultString, filename);
      setDone(true);
    } else if (data.exportSize === EXPORT_FIRST_N || data.exportSize === EXPORT_ALL) {
      var exportFirst = data.exportSize === EXPORT_FIRST_N ? data.exportFirst : formState.data.count;
      var pagesToFetch = Math.ceil(exportFirst / paginationSize);
      setExporting(true);

      var sleep = function sleep(ms) {
        return new Promise(function (resolve) {
          return setTimeout(resolve, ms);
        });
      };

      var fetcher = /*#__PURE__*/function () {
        var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var data, i, result;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  data = [];
                  i = 1;

                case 2:
                  if (!(i <= pagesToFetch)) {
                    _context.next = 11;
                    break;
                  }

                  _context.next = 5;
                  return getPersonsFromFormData(_objectSpread(_objectSpread({}, formState.form), {}, {
                    currentPage: i,
                    resultsPerPage: paginationSize
                  }));

                case 5:
                  result = _context.sent;
                  result.results.forEach(function (entry) {
                    return data.push(entry);
                  });
                  setProgress(i / (pagesToFetch - 1));

                case 8:
                  i++;
                  _context.next = 2;
                  break;

                case 11:
                  return _context.abrupt("return", data);

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function fetcher() {
          return _ref17.apply(this, arguments);
        };
      }();

      fetcher().then(function (result) {
        var resultString = dataToString(result, data.exportFileFormat, data);
        downloadStringAsFile(resultString, filename);
        setExporting(false);
        setDone(true);
      }).catch(function (error) {
        console.error(error);
        setError(true);
        setExporting(false);
        setDone(true);
      }); // TODO
    } else {
      throw new Error();
    } // TODO

  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      variant: "secondary",
      disabled: disabled,
      onClick: handleButtonClick
    }, props), {}, {
      children: /*#__PURE__*/_jsx(FileEarmarkArrowDownFill, {
        className: "icon"
      })
    })), /*#__PURE__*/_jsx(Modal, {
      show: show,
      onHide: handleHide,
      children: /*#__PURE__*/_jsx(FinalForm, {
        onSubmit: submitHandler,
        mutators: {
          setValue: function setValue(_ref18, state, _ref19) {
            var _ref20 = _slicedToArray(_ref18, 2),
                field = _ref20[0],
                value = _ref20[1];

            var changeValue = _ref19.changeValue;
            return changeValue(state, field, function () {
              return value;
            });
          }
        },
        initialValues: {
          exportFileFormat: EXTENSION_CSV,
          exportSize: EXPORT_CURRENT,
          exportFirst: paginationSize,
          exportCsvFieldSeparator: 'comma',
          exportCsvLineSeparator: 'crlf',
          exportJsonPretty: ['checked']
        },
        render: renderForm
      })
    })]
  });
}
DownloadButton.propTypes = {
  disabled: PropTypes.bool.isRequired
};